module.exports = __webpack_public_path__ + "img/appointment.ca9275f.jpg";